export default function ImagePreview({ url }) {
  return <img src={url} height={200} width={200} alt="productImage" />;
}
